import React from "react";

/** Inside a desk's row when routing: tell this desk who introduced the case — first name only. */
export function ShareIntroducerTick({ first, on, onToggle, testId }) {
  if (!first) return null;
  const flip = (e) => { e.preventDefault(); e.stopPropagation(); onToggle(); };
  return (
    <span role="checkbox" aria-checked={on} tabIndex={0} onClick={flip}
          onKeyDown={(e) => { if (e.key === " " || e.key === "Enter") flip(e); }}
          style={{ display: "inline-flex", alignItems: "center", gap: 7, marginTop: 7, fontSize: 12.5, color: "var(--ink-3)", cursor: "pointer" }}
          data-testid={testId}>
      <span style={{ width: 14, height: 14, borderRadius: 4, border: `1.5px solid ${on ? "var(--accent)" : "var(--line-2)"}`,
                     background: on ? "var(--accent)" : "#fff", color: "#fff", fontSize: 10, display: "grid", placeItems: "center" }}>
        {on ? "✓" : ""}
      </span>
      Tell them it came from {first}
    </span>
  );
}

export default ShareIntroducerTick;
